export default __webpack_public_path__ + "static/media/Videography3.68a69df6.png";